export default __webpack_public_path__ + "static/media/sliderPart2.cd4662af.png";